import type { Example } from '../types';

export const parameterSnapshotsExample: Example = {
  id: 'parameter-snapshots',
  title: 'Parameter Snapshots',
  categoryId: 'parameters',
  description: 'Named presets defined in code, switchable with one click',
  scadCode: `/* Parameter Snapshots */

// markdown:tip
// **Parameter Snapshots** — Define named parameter presets directly in your
// SCAD code. Switch between them instantly using the snapshot picker in the
// parameters panel — or click **Copy as Snapshot** to save the current values.

/* [Snapshots]
Compact:  width=30, depth=20, height=15, corner_r=2, has_hole=false
Standard: width=60, depth=40, height=30, corner_r=5, has_hole=true
Large:    width=90, depth=60, height=45, corner_r=8, has_hole=true
*/

/* [Dimensions] */

// Width
width = 60; // [15:1:100]

// Depth
depth = 40; // [15:1:80]

// Height
height = 30; // [10:1:60]

// Corner radius
corner_r = 5; // [0:0.5:15]

/* [Options] */

// Add centre hole?
has_hole = true;

// Hole diameter
hole_d = 12; // [4:0.5:30] {has_hole == true}

// Color
// color
part_color = [0.25, 0.6, 0.45];

// --- parameters end ---

module rounded_box(w, d, h, r) {
  rr = max(0.01, min(r, w/2 - 0.01, d/2 - 0.01));
  minkowski() {
    cube([w - 2*rr, d - 2*rr, h], center=true);
    cylinder(r=rr, h=0.01, $fn=32, center=true);
  }
}

color(part_color)
difference() {
  rounded_box(width, depth, height, corner_r);
  if (has_hole)
    cylinder(d=hole_d, h=height + 1, center=true, $fn=48);
}
`,
};
